import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { Button, ButtonProps } from '../button/button';

interface TextInputActionProps extends Pick<ButtonProps, 'disabled' | 'isLoading' | 'color' | 'type'> {
  icon: React.ReactNode;
  onClick: () => void;
  tooltip?: string;
}

export function TextInputAction({ icon, onClick, tooltip, color = 'secondary', ...props }: TextInputActionProps) {
  const button = (
    <Button size="md" shape="round" appearance="none" color={color} onClick={onClick} $width="32px" {...props}>
      {icon}
    </Button>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }
  return button;
}
